import {
  GetUrlParams,
  ORDERING_DIRECTION_DESC,
  OrderingParams,
  PaginationParams,
} from '@lib/enums/urls';

export const TOP_USERS_LIMIT = 5;

// The shared ORDERING_PARAMS default to `createdAt`, which this query cannot
// sort by — rank by spend instead, matching the `AiUsageByUserModal` behind
// the "view all" action.
export const TOP_USERS_DEFAULT_ORDERING: OrderingParams = {
  [GetUrlParams.OrderingField]: 'creditsUsed',
  [GetUrlParams.OrderingDirection]: ORDERING_DIRECTION_DESC,
};

export const TOP_USERS_PAGINATION: PaginationParams = {
  [GetUrlParams.Page]: '1',
  [GetUrlParams.PerPage]: String(TOP_USERS_LIMIT),
};
